module.exports = __webpack_public_path__ + "img/payment.95360825.png";